import styled, { keyframes } from 'styled-components';
import * as ModalPrimitive from '@radix-ui/react-dialog';
import { Z_INDEX } from '../../constants/zIndex';

interface Props {
  affectedBySidebar?: boolean;
  onClose?: ()=>void
}

export const overlayShow = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const DialogOverlay = styled(ModalPrimitive.Overlay)`
  background-color: rgba(255, 255, 255, 0.8);
  position: fixed;
  inset: 0;
  z-index: ${Z_INDEX.MODAL_OVERLAY};
  animation: ${overlayShow} 150ms cubic-bezier(0.16, 1, 0.3, 1);
`;

export const ModalPrimitiveContent = styled(ModalPrimitive.Content) <Props>`
  background-color: ${props => props.theme.colors.card_300};
  border-radius: 6px;
  box-shadow:
    hsl(206 22% 7% / 35%) 0px 10px 38px -10px,
    hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
  position: fixed;
  top: 50%;
  left: ${props => (props.affectedBySidebar ? '58%' : '50%')};
  transform: translate(-50%, -50%);
  width: 100vw;
  max-width: 60%;
  max-height: 85vh;
  padding: 25px;
  z-index: ${Z_INDEX.MODAL_CONTENT};
  animation: contentShow 150ms cubic-bezier(0.16, 1, 0.3, 1);
  
  @keyframes contentShow {
    from {
      opacity: 0;
      transform: scale(0.9) translate(-50%, -50%);
    }
    to {
      opacity: 1;
      transform: scale(1) translate(-50%, -50%);
    }
  }
`;
